// Imports => MOBX
import { observable, computed, makeObservable, action, toJS } from 'mobx';

let app = {};

export class FaqsStore {
  constructor(store) {
    makeObservable(this);
    app.store = store;
  }

  @observable
  items = [];

  @observable
  loading = {
    status: false,
    message: undefined,
  };

  @computed
  get is_loading() {
    return this.loading.status;
  }

  @computed
  get all_faqs() {
    return this.items ? toJS(this.items) : [];
  }

  @action
  setLoadingStatus = (status) => {
    this.loading.status = status;
  };

  @action
  setFaqs = (items) => {
    this.items = items;
  };

  @action
  fetchFaqs = async () => {
    this.loading.status = true;

    try {
      const faqs = await app.store.api.faqs.list();
      // Sort FAQs by their sort property
      const sortedFaqs = faqs.sort((a, b) => a.sort - b.sort);
      this.setFaqs(sortedFaqs);
    } catch (e) {
      // Handle error silently but set empty faqs to avoid UI issues
      this.setFaqs([]);
    } finally {
      this.setLoadingStatus(false);
    }
  };
}

export default FaqsStore;
